import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { RolesActions } from './roles.actions';
import { RoleService } from '../../services/role.service';

@Injectable()
export class RolesEffects {
  private actions$ = inject(Actions);
  private service = inject(RoleService);

  loadRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RolesActions.loadRoles),
      mergeMap(() =>
        this.service.getAll().pipe(
          map(roles => RolesActions.loadRolesSuccess({ roles })),
          catchError(err => of(RolesActions.loadRolesFailure({ error: err.message })))
        )
      )
    )
  );

  createRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RolesActions.createRole),
      mergeMap(({ data }) =>
        this.service.create(data).pipe(
          map(role => RolesActions.createRoleSuccess({ role })),
          catchError(err => of(RolesActions.createRoleFailure({ error: err.message })))
        )
      )
    )
  );

  updateRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RolesActions.updateRole),
      mergeMap(({ id, data }) =>
        this.service.update(id, data).pipe(
          map(role => RolesActions.updateRoleSuccess({ role })),
          catchError(err => of(RolesActions.updateRoleFailure({ error: err.message })))
        )
      )
    )
  );

  deleteRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RolesActions.deleteRole),
      mergeMap(({ id }) =>
        this.service.delete(id).pipe(
          map(() => RolesActions.deleteRoleSuccess({ id })),
          catchError(err => of(RolesActions.deleteRoleFailure({ error: err.message })))
        )
      )
    )
  );

  addRule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RolesActions.addRule),
      mergeMap(({ roleId, data }) =>
        this.service.addRule(roleId, data).pipe(
          map(rule => RolesActions.addRuleSuccess({ roleId, rule })),
          catchError(err => of(RolesActions.addRuleFailure({ error: err.message })))
        )
      )
    )
  );

  deleteRule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RolesActions.deleteRule),
      mergeMap(({ roleId, ruleId }) =>
        this.service.deleteRule(ruleId).pipe(
          map(() => RolesActions.deleteRuleSuccess({ roleId, ruleId })),
          catchError(err => of(RolesActions.deleteRuleFailure({ error: err.message })))
        )
      )
    )
  );
}
